/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react"
import type { PageSize } from "./types"

interface UsePdfDocumentResult {
	pdfDoc: React.MutableRefObject<any>
	totalPages: number
	loading: boolean
	originalPageSizes: Map<number, PageSize>
}

export const usePdfDocument = (pdfUrl: string): UsePdfDocumentResult => {
	const [loading, setLoading] = useState(false)
	const [totalPages, setTotalPages] = useState(0)
	const [originalPageSizes, setOriginalPageSizes] = useState<
		Map<number, PageSize>
	>(new Map())
	const pdfDoc = useRef<any>(null)

	useEffect(() => {
		let cancelled = false

		const loadPdf = async () => {
			if (!pdfUrl) return
			setLoading(true)
			try {
				const downloadPdfTask = (window as any).pdfjsLib.getDocument(pdfUrl)
				const doc = await downloadPdfTask.promise
				if (cancelled) return

				pdfDoc.current = doc
				setTotalPages(doc.numPages)

				const sizes = new Map<number, PageSize>()
				for (let i = 1; i <= doc.numPages; i++) {
					const page = await doc.getPage(i)
					const viewport = page.getViewport({ scale: 1 })
					sizes.set(i, { width: viewport.width, height: viewport.height })
				}
				if (!cancelled) {
					setOriginalPageSizes(sizes)
				}
			} catch (error) {
				console.error("Error loading PDF:", error)
			} finally {
				if (!cancelled) setLoading(false)
			}
		}

		loadPdf()
		return () => {
			cancelled = true
		}
	}, [pdfUrl])

	return { pdfDoc, totalPages, loading, originalPageSizes }
}
